import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';
import 'fix-date';
import App from './App';

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')
);
